import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import * as InstanceActions from '../actions/instance.actions';
import * as InstanceSelectors from '../selectors/instance.selectors';
import * as InstanceState from '../reducers/instance.reducer';

@Injectable()
export class InstanceStoreFacade {
  constructor(private readonly store: Store<InstanceState.State>) {}

  fetchInstances$ = () => this.store.dispatch(InstanceActions.loadInstances());

  getInstances$ = this.store.pipe(select(InstanceSelectors.selectAllInstances));
}
